import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../../../_metronic/helpers'
import { Dealer, DealerQueryResponse} from './_models'

const ADMIN_API_URL = process.env.REACT_APP_API_URL
const GET_LIST_URL = `${ADMIN_API_URL}/master/listDealer`
const MY_URL = `${ADMIN_API_URL}/master/dealer`

const getDealer = (query: string): Promise<DealerQueryResponse> => {
  return axios
    .get(`${GET_LIST_URL}?${query}`)
    .then((d: AxiosResponse<DealerQueryResponse>) => d.data)
}

const getDealerById = (id: ID): Promise<Dealer | undefined> => {
  return axios
    .get(`${ MY_URL}/${id}`)
    .then((response: AxiosResponse<Response<Dealer>>) => response.data)
    .then((response: Response<Dealer>) => response.data)
}


const createDealer = (dealer: Dealer): Promise<Dealer | undefined> => {
  return axios
    .post( MY_URL, dealer)
    .then((response: AxiosResponse<Response<Dealer>>) => response.data)
    .then((response: Response<Dealer>) => response.data)
}

const updateDealer = (dealer: Dealer): Promise<Dealer | undefined> => {
  return axios
    .put(`${ MY_URL}/${dealer.id}`, dealer)
    .then((response: AxiosResponse<Response<Dealer>>) => response.data)
    .then((response: Response<Dealer>) => response.data)
}

const deleteDealer = (id: ID): Promise<void> => {
  return axios.delete(`${MY_URL}/${id}`).then(() => {})
}

const deleteSelectedDealers = (ids: Array<ID>): Promise<void> => {
  const requests = ids.map((id) => axios.delete(`${MY_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

const statusDealer = (id: ID): Promise<void> => {
  return axios.put(`${MY_URL}/status/${id}`).then(() => {})
}



export {  getDealer, getDealerById,createDealer,updateDealer,deleteDealer, deleteSelectedDealers,statusDealer }
